import type { SVGProps } from 'react';

export const ArenaCashBg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 84 117"
    fill="none"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M34.8654 47.4648L67.1731 49.4591L78.0769 62.6216L73.9039 86.1545L56.9423 100.381H44.8269L41.8654 117H24.5L27.4615 100.381H10.7692L0 87.4841L18.5769 71.9284L25.8462 80.7034H48.7308L52.2308 77.7784L53.4423 71.1307L51.8269 69.2693L19.6538 67.275L8.75 54.1125L12.7885 30.8454L29.75 16.6193H42.4039L45.3654 0H62.7308L59.7692 16.6193H73.5L84 29.117L65.4231 44.6727L58.4231 36.2966H37.9615L34.4615 39.2216L33.3846 45.6034L34.8654 47.4648Z"
      fill="currentColor"
    />
  </svg>
);
